/* Source: /home/sidsolaiyappan/skooch_ai/shared/online_status.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { setStoreIsOnline } from "./store.js";
function initOnlineWatcher() {
  try {
    if (window.__skoochOnlineWatcherInit) {
      return;
    }
    window.__skoochOnlineWatcherInit = true;
    window.addEventListener("online", () => {
      try {
        setStoreIsOnline(true);
      } catch (__jac_e) {
        if (true) {
          let _e1 = __jac_e;
        } else {
          throw __jac_e;
        }
      }
    });
    window.addEventListener("offline", () => {
      try {
        setStoreIsOnline(false);
      } catch (__jac_e) {
        if (true) {
          let _e2 = __jac_e;
        } else {
          throw __jac_e;
        }
      }
    });
    try {
      setStoreIsOnline(navigator.onLine);
    } catch (__jac_e) {
      if (true) {
        let _e3 = __jac_e;
      } else {
        throw __jac_e;
      }
    }
  } catch (__jac_e) {
    if (true) {
      let _e = __jac_e;
    } else {
      throw __jac_e;
    }
  }
}
export {initOnlineWatcher};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:initOnlineWatcher": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=online_status.js.map
